import { useState } from "react";
import { Link } from "react-router-dom";
import AuthLayout from "@/components/layout/AuthLayout";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const { resetPassword } = useAuth();
  const [sent, setSent] = useState(false);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    await resetPassword(email.trim());
    setBusy(false);
    setSent(true);
  };

  return (
    <AuthLayout title="Reset your password" subtitle="We'll email you a secure link to set a new password.">
      {sent ? (
        <div className="space-y-5" data-testid="reset-sent">
          <div className="flex items-start gap-3 rounded-lg border border-accent/40 bg-accent-subtle p-4">
            <MailCheck className="mt-0.5 h-5 w-5 text-accent" />
            <p className="text-sm text-muted-foreground">
              If an account exists for <span className="font-medium text-foreground">{email || "that email"}</span>, a reset link is on its way. Open it to set a new password.
            </p>
          </div>
          <Button asChild variant="outline" className="w-full">
            <Link to="/login" data-testid="back-to-login"><ArrowLeft className="mr-2 h-4 w-4" /> Back to sign in</Link>
          </Button>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div className="space-y-1.5">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" placeholder="you@nirvana.example" value={email}
              onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" required />
          </div>
          <Button type="submit" className="w-full" disabled={busy} data-testid="forgot-submit">
            {busy ? "Sending…" : "Send reset link"}
          </Button>
          <Button asChild variant="ghost" className="w-full">
            <Link to="/login"><ArrowLeft className="mr-2 h-4 w-4" /> Back to sign in</Link>
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
